import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getParticipantVideos } from "../../../apis/actions/participants.actions";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import Selects from "../../../biblio/Selects/Selects";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { getDateRange, scroll } from "../../../components/utils/utils";
import CustomConfigProvider from "../ProfileHeader";
import ParticipantMediaCollapse from "../ParticipantMediaCollapse";

const ParticipantVideos = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  const [participantId, setParticipantId] = useState<number | null>(null);
  const itemPerPage = 5;

  const { videos, videosTotalPages, videoParticipants, loading } = useSelector(
    (state: RootState) => state?.participants
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [state, participantId]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getParticipantVideos({
        participant_id: participantId,
        limit: itemPerPage,
        page: currentPage,
        date_from: date_from,
        date_to: date_to,
      })
    );
  }, [dispatch, currentPage, state, participantId]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const isFiltered = state.year !== "" || participantId !== null;

  return (
    <>
      <CustomConfigProvider
        title="الفيديوهات"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        <Selects
          options={videoParticipants}
          selectPlaceholder="المتبرع"
          onChange={(value: any) => setParticipantId(value?.value ?? null)}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : !videos?.length ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          {isFiltered
            ? "لا توجد فيديوهات تتوافق مع البحث الذي قمت به"
            : "لا توجد فيديوهات"}
        </p>
      ) : (
        <div ref={currentRef}>
          <ParticipantMediaCollapse
            groups={videos}
            loading={loading}
            isVideo
            emptyText="لا توجد فيديوهات"
          />
          <div className="takaful--pagination-container">
            {videosTotalPages > 1 && (
              <PaginationComponent
                active={currentPage}
                total={videosTotalPages * itemPerPage}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ParticipantVideos;
